import { Alert, AlertProps, Snackbar, SnackbarOrigin } from '@mui/material'
import React, { useState, useEffect } from 'react'

interface UpdateTitleSnackbarProps {
  errors?: (string | null)[]
  msgs?: (string | null)[]
}

const UpdateTitleSnackbar: React.FC<UpdateTitleSnackbarProps> = ({ errors = [], msgs = [] }) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [severity, setSeverity] = useState<AlertProps['severity']>('success')

  useEffect(() => {
    const errorMessage = errors.find(err => err !== null)
    if (errorMessage) {
      setMessage(errorMessage)
      setSeverity('error')
      setOpen(true)
      return
    }

    // Then check for success messages
    const successMessage = msgs.find(msg => msg !== null)
    if (successMessage) {
      setMessage(successMessage)
      setSeverity('success')
      setOpen(true)
      return
    }

    // If no messages or errors, close the Snackbar
    setOpen(false)
  }, [errors, msgs])

  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' } as SnackbarOrigin}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  )
}

export default UpdateTitleSnackbar
